(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valor-add-all"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar = document.getElementById('valor-add-all');
  if (!bar) return;

  var summaryEl = bar.querySelector('.vaa-bar__summary');
  var btn = bar.querySelector('.vaa-bar__btn');

  function getItems() {
    var items = [];
    document.querySelectorAll('.vqa-wrap[data-variant-id]').forEach(function (wrap) {
      var input = wrap.querySelector('.vqa__qty-input');
      var qty = input ? Math.max(0, parseInt(input.value) || 0) : 0;
      if (qty < 1) return;
      var atcBtn = wrap.querySelector('.vqa__btn');
      if (atcBtn && atcBtn.disabled) return;
      items.push({ id: parseInt(wrap.dataset.variantId), quantity: qty, brand: wrap.dataset.productBrand || '', wrap: wrap });
    });
    return items;
  }

  function markAdded(wrap, qty) {
    if (typeof window.__valorProductCardMarkAdded === 'function') {
      window.__valorProductCardMarkAdded(wrap, qty);
      return;
    }

    var card = wrap.closest('.vpc-card, .product-card, product-card');
    if (card) card.classList.add('vpc-card--just-added', 'just-added');

    var atcBtn = wrap.querySelector('.vqa__btn');
    if (atcBtn) {
      var label = atcBtn.querySelector('.vpc-add__label, .vqa__label');
      if (label) label.textContent = 'Added · ' + qty;
      atcBtn.dataset.added = '';
      atcBtn.disabled = true;
    }

    var input = wrap.querySelector('.vqa__qty-input');
    if (input) {
      input.value = '';
      input.setAttribute('readonly', 'true');
      input.classList.add('vqa__qty-input--added');
    }
  }

  function update() {
    var items = getItems();
    var totalQty = items.reduce(function (s, i) { return s + i.quantity; }, 0);
    var variantCount = items.length;
    if (totalQty === 0) {
      bar.setAttribute('hidden', '');
      return;
    }
    bar.removeAttribute('hidden');
    summaryEl.textContent = variantCount + (variantCount === 1 ? ' variant' : ' variants') + ', ' + totalQty + ' units';
  }

  // Update on any qty input change
  document.addEventListener('input', function (e) {
    if (e.target.matches('.vqa__qty-input')) update();
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('.vqa__qty-btn')) setTimeout(update, 0);
  });

  // Initial scan (cards may load after script)
  setTimeout(update, 0);

  btn.addEventListener('click', async function () {
    var items = getItems();
    if (!items.length) return;

    bar.classList.add('vaa-bar--loading');
    btn.disabled = true;

    try {
      var payload = items.map(function (item) {
        var payloadItem = { id: item.id, quantity: item.quantity };
        return payloadItem;
      });

      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: payload })
      });
      if (!res.ok) return;

      var cartData = await (await fetch('/cart.js')).json();
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { cart: cartData, resource: cartData, sourceId: '', data: { itemCount: cartData.item_count ?? 0 } }
      }));

      items.forEach(function (item) {
        markAdded(item.wrap, item.quantity);
      });

      bar.classList.remove('vaa-bar--loading');
      bar.classList.add('vaa-bar--added');
      await new Promise(function (r) { setTimeout(r, 1500); });
      bar.classList.remove('vaa-bar--added');
    } catch (_) {
    } finally {
      bar.classList.remove('vaa-bar--loading');
      btn.disabled = false;
      update();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valor-alert-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.vab__collapse');
  if (!btn) return;
  var banner = btn.closest('.vab');
  if (!banner) return;
  var collapsed = banner.classList.toggle('vab--collapsed');
  btn.setAttribute('aria-label', collapsed ? 'Expand alert' : 'Collapse alert');
  btn.setAttribute('title',      collapsed ? 'Expand this notice' : 'Collapse this notice');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valor-cart"] && !Shopify.designMode) return;
  try {
    
(function () {
  function vcConfirm(msg, okLabel, danger, hideCancel) {
    var dlg   = document.getElementById('vc-confirm-dialog');
    var msgEl = document.getElementById('vc-dialog-msg');
    var okBtn = document.getElementById('vc-dialog-ok');
    var canBtn = document.getElementById('vc-dialog-cancel');
    if (!dlg) return Promise.resolve(hideCancel ? (window.alert(msg), true) : window.confirm(msg));
    msgEl.textContent = msg;
    okBtn.textContent = okLabel || 'OK';
    okBtn.classList.toggle('danger', !!danger);
    canBtn.style.display = hideCancel ? 'none' : '';
    dlg.showModal();
    return new Promise(function (resolve) {
      function cleanup() { dlg.close(); okBtn.removeEventListener('click', onOk); canBtn.removeEventListener('click', onCancel); dlg.removeEventListener('cancel', onCancel); }
      function onOk()     { cleanup(); resolve(true);  }
      function onCancel() { cleanup(); resolve(false); }
      okBtn.addEventListener('click',  onOk);
      canBtn.addEventListener('click', onCancel);
      dlg.addEventListener('cancel',   onCancel);
    });
  }
  function vcAlert(msg) {
    return vcConfirm(msg, 'OK', false, true);
  }
  // Lightweight full-screen busy overlay with a spinner; returns handles to update/hide it.
  function vcShowBusy(text) {
    var overlay = document.createElement('div');
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.35);z-index:10000;display:flex;align-items:center;justify-content:center;';
    overlay.innerHTML =
      '<div style="background:#fff;border-radius:12px;padding:22px 26px;display:flex;align-items:center;gap:14px;box-shadow:0 8px 32px rgba(0,0,0,0.18);">' +
        '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#1D2636" stroke-width="2.5" style="animation:vc-spin 0.8s linear infinite"><circle cx="12" cy="12" r="9" stroke-dasharray="28 57" stroke-linecap="round"/></svg>' +
        '<span class="vc-busy-text" style="font-size:14px;color:#2B3A55;font-weight:500;"></span>' +
      '</div>';
    overlay.querySelector('.vc-busy-text').textContent = text || 'Loading…';
    document.body.appendChild(overlay);
    return {
      setText: function (t) { var el = overlay.querySelector('.vc-busy-text'); if (el) el.textContent = t; },
      hide: function () { overlay.remove(); },
    };
  }

  class ValorCartPage extends HTMLElement {
    connectedCallback() {
      // Hide the multi-ship section immediately so it doesn't flash on load
      this._distSection = document.querySelector('multi-ship')?.closest('.shopify-section') || null;
      if (this._distSection) this._distSection.style.display = 'none';

      this._bindEvents();
      this._initCricket();
      this._initSavedCarts();
      this._initStoreCredit();
      this._initNetTerms();
      this._initMultiAddr();
	  //use document.querySelector('valor-cart-page')._initStoreCredit() in the console for test

    }

    _bindEvents() {
      // Qty steppers
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-vc-step]');
        if (!btn) return;
        const line = btn.closest('[data-vc-line]');
        if (!line) return;
        const input = line.querySelector('[data-vc-qty]');
        if (!input) return;
        const step = parseInt(btn.getAttribute('data-vc-step'), 10);
        const cur = Math.max(0, parseInt(input.value || '0', 10));
        const next = Math.max(0, cur + step);
        input.value = next;
        this._updateLineAjax(line, next);
      });

      // Note toggle
      this.addEventListener('click', (e) => {
        const toggle = e.target.closest('[data-vc-note-toggle]');
        if (!toggle) return;
        const wrap = toggle.closest('.vc-note-wrap');
        wrap.classList.toggle('is-open');
        if (wrap.classList.contains('is-open')) wrap.querySelector('[data-vc-note]')?.focus();
      });

      // Note save
      this.addEventListener('change', (e) => {
        const note = e.target.closest('[data-vc-note]');
        if (!note) return;
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: note.value })
        });
      });

      this.addEventListener('change', (e) => {
        const input = e.target.closest('[data-vc-qty]');
        if (!input) return;
        const line = input.closest('[data-vc-line]');
        if (!line) return;
        const qty = Math.max(0, parseInt(input.value || '0', 10));
        input.value = qty;
        this._updateLineAjax(line, qty);
      });

      // Remove
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-vc-remove]');
        if (!btn) return;
        const line = btn.closest('[data-vc-line]');
        if (!line) return;
        this._updateLineAjax(line, 0, true);
      });

      // Clear cart
      this.addEventListener('click', (e) => {
        if (!e.target.closest('[data-vc-clear-cart]')) return;
        vcConfirm('Remove all items from your cart?', 'Clear cart', true).then((ok) => { if (ok) this._clearCart(); });
      });

      // Single-address checkout — write a single-entry _order so order processing
      // has the BC customer info even without the distribution component.
      const checkoutLinkEl = this.querySelector('#vc-checkout-link');
      if (checkoutLinkEl) {
        checkoutLinkEl.addEventListener('click', async (e) => {
          e.preventDefault();
          if (checkoutLinkEl.hasAttribute('data-min-order')) return;
          const href = checkoutLinkEl.href;
          checkoutLinkEl.dataset.loading = '';
          try {
            const [customerData, cartRes] = await Promise.all([
              window.__vaCustomerInfo,
              fetch('/cart.js'),
            ]);
            const shipTo = customerData?.defaultShipTo || null;
            const cart  = cartRes.ok ? await cartRes.json() : null;
            const erpNo = customerData?.No || customerData?.no || '';
            if (!erpNo) { delete checkoutLinkEl.dataset.loading; window.location.href = href; return; }

            const items = {};
            if (cart?.items?.length) {
              for (const item of cart.items) {
                const vid = String(item.variant_id);
                items[vid] = (items[vid] || 0) + item.quantity;
              }
            }

            const attrs = {
              _order: JSON.stringify([{
                id:          shipTo?.systemId   || '',
                bc_customer: shipTo?.customerNo || '',
                bc_ship_to:  shipTo?.code       || '',
                addr:        shipTo?.addr       || '',
                contact:     { name: shipTo?.contact || '', phone: shipTo?.phoneNo || '' },
                items,
              }]),
              _address: JSON.stringify([{
                id:           	shipTo?.systemId          || '',
                bc_customer:   	shipTo?.customerNo        || '',
                bc_ship_to:    	shipTo?.code              || '',
                company:      	shipTo?.company           || '',
                address:       	shipTo?.address           || '',
                address2:      	shipTo?.address2          || '',
                city:          	shipTo?.city              || '',
                contact:       	shipTo?.contact           || '',
                phone:       	shipTo?.phoneNo           || '',
                country: 		shipTo?.countryRegionCode || '',
                zip:          	shipTo?.postCode          || '',
                state:         	shipTo?.state             || '',
              }]),
              _lineitems: '',
            };

            const _auth = window.__vaAuth;
            const variantKey = cart ? cart.items
              .map(i => `${i.variant_id}:${i.quantity}`).sort().join(',') : '';
            await Promise.all([
              fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ attributes: attrs }),
              }),
              (_auth && variantKey) ? fetch(_auth.proxy, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'clear-shipping-total', customer_id: _auth.customer_id, ts: _auth.ts, token: _auth.token, shop: Shopify.shop, variant_key: variantKey }),
              }).catch(() => {}) : Promise.resolve(),
            ]);
          } catch (_) {}
          delete checkoutLinkEl.dataset.loading;
          window.location.href = href;
        });
      }

      // Multi-location toggle
      this.addEventListener('click', (e) => {
        if (!e.target.closest('[data-vc-dist-toggle]')) return;
        this._toggleDistView();
      });

      // Show banner as soon as customerInfo resolves with multiAddress true
      window.__vaCustomerInfo?.then((data) => {
        //if (!data?.multiAddress) return;
        const banner = this.querySelector('.vc-dist-banner');
        if (banner) {
          banner.removeAttribute('hidden');
          requestAnimationFrame(() => banner.classList.add('vc-dist-banner--show'));
        }
      });
    }

    _toggleDistView() {
      const layout = this.querySelector('.vc-layout');
      const btn    = this.querySelector('[data-vc-dist-toggle]');
      const label  = btn?.querySelector('[data-vc-toggle-label]');
      const isDistMode = this._distSection && this._distSection.style.display !== 'none';

      if (isDistMode) {
        if (this._distSection) this._distSection.style.display = 'none';
        if (layout) layout.style.display = '';
        if (label) label.textContent = btn.dataset.labelDist || 'Multi-location shipping';
        this.classList.remove('vc-dist-mode');
      } else {
        if (this._distSection) this._distSection.style.display = '';
        if (layout) layout.style.display = 'none';
        if (label) label.textContent = btn.dataset.labelCart || 'Simple cart view';
        this.classList.add('vc-dist-mode');
        requestAnimationFrame(() => {
          const multiShip = document.querySelector('multi-ship');
          if (!multiShip) return;
          if (multiShip._addressLoadFailed) {
            // Previous address fetch failed — retry now that the user is switching to this view
            multiShip.reloadTable();
          } else {
            multiShip.syncCartWidth();
            multiShip.syncHeaderOffset();
          }
        });
      }
    }

    _updateLineAjax(lineEl, qty, remove) {
      const variantId = lineEl.getAttribute('data-variant-id');
      if (!variantId) return;
      lineEl.style.opacity = '0.5';
      lineEl.style.pointerEvents = 'none';

      // Note: /cart/change.js regenerates line item keys when an order discount is applied
      // (Shopify recalculates discount allocation per item). /cart/update.js does not.
      // We use variant ID (not key) as the id to avoid stale-key 400 errors.
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: remove ? 0 : qty }),
      })
        .then(async (r) => {
          if (!r.ok) {
            // 422 = quantity exceeds inventory — re-fetch real cart and snap input back
            const errData = await r.json().catch(() => ({}));
            const cart = await fetch('/cart.js').then((c) => c.json()).catch(() => null);
            lineEl.style.opacity = '1';
            lineEl.style.pointerEvents = '';
            if (cart) {
              const actual = cart.items.find((i) => String(i.variant_id) === variantId);
              const actualQty = actual ? actual.quantity : 0;
              const qtyInput = lineEl.querySelector('[data-vc-qty]');
              if (qtyInput) qtyInput.value = actualQty;
              const unitCents = parseInt(lineEl.getAttribute('data-unit'), 10) || 0;
              const subEl = lineEl.querySelector('[data-vc-subtotal]');
              if (subEl) subEl.textContent = this._money((unitCents * actualQty) / 100);
              this._applyCartData(cart);
            }
            const msg = errData.description || errData.message || 'Quantity not available';
            const errEl = lineEl.querySelector('.vc-qty-error') || Object.assign(document.createElement('div'), { className: 'vc-qty-error' });
            errEl.textContent = msg;
            if (!errEl.parentNode) lineEl.appendChild(errEl);
            setTimeout(() => errEl.remove(), 4000);
            return;
          }
          const cart = await r.json();
          if (remove || qty === 0) {
            lineEl.style.transform = 'translateX(12px)';
            lineEl.style.opacity = '0';
            setTimeout(() => {
              lineEl.remove();
              this._applyCartData(cart);
            }, 200);
          } else {
            lineEl.style.opacity = '1';
            lineEl.style.pointerEvents = '';
            const unitCents = parseInt(lineEl.getAttribute('data-unit'), 10) || 0;
            const subEl = lineEl.querySelector('[data-vc-subtotal]');
            if (subEl) subEl.textContent = this._money((unitCents * qty) / 100);
            this._applyCartData(cart);
          }
        })
        .catch(() => {
          lineEl.style.opacity = '1';
          lineEl.style.pointerEvents = '';
        });
    }

    _clearCart() {
      const items = {};
      this.querySelectorAll('[data-vc-line]').forEach((el) => {
        const key = el.getAttribute('data-key');
        if (key) items[key] = 0;
      });
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ updates: items }),
      })
        .then((r) => r.json())
        .then(() => { location.reload(); });
    }

    _applyCartData(cart) {
      const total = cart.total_price;
      const itemCount = cart.item_count;
      const lineCount = cart.items ? cart.items.length : 0;

      // Head meta
      const lineCountEl = this.querySelector('[data-vc-line-count]');
      if (lineCountEl) lineCountEl.textContent = lineCount + (lineCount === 1 ? ' line item' : ' line items');
      const totalUnitsEl = this.querySelector('[data-vc-total-units]');
      if (totalUnitsEl) totalUnitsEl.textContent = itemCount.toLocaleString('en-US');

      // Summary stats
      const statLines = this.querySelector('[data-vc-stat-lines]');
      if (statLines) statLines.textContent = lineCount;
      const statUnits = this.querySelector('[data-vc-stat-units]');
      if (statUnits) statUnits.textContent = itemCount.toLocaleString('en-US');

      // Totals
      const subDisplay = this.querySelector('[data-vc-subtotal-display]');
      if (subDisplay) subDisplay.textContent = this._money((cart.original_total_price ?? total) / 100);
      const productDiscount = (cart.original_total_price ?? 0) - (cart.items_subtotal_price ?? total);
      const savingsRow     = this.querySelector('[data-vc-savings-row]');
      const savingsDisplay = this.querySelector('[data-vc-savings-display]');
      if (savingsRow) savingsRow.hidden = productDiscount <= 0;
      if (savingsDisplay) savingsDisplay.textContent = '\u2212' + this._money(productDiscount / 100);
      const grandTotal = this.querySelector('[data-vc-grand-total]');
      if (grandTotal) grandTotal.textContent = this._money((cart.items_subtotal_price ?? total) / 100);

      // Min order gate ($25) — use original_total_price (pre-discount) so credit memos don't block checkout
      const checkoutLink = this.querySelector('#vc-checkout-link');
      const belowMin = (cart.original_total_price ?? total) < 2500;
      if (checkoutLink) checkoutLink.toggleAttribute('data-min-order', belowMin);

      // Freight bar
      const freightBox = this.querySelector('[data-vc-freight]');
      if (freightBox) {
        const threshold = parseInt(freightBox.getAttribute('data-threshold'), 10) || 0;
        if (threshold > 0) {
          const fill = this.querySelector('[data-vc-freight-fill]');
          const pct = Math.min(100, Math.round((total / threshold) * 100));
          if (fill) fill.style.width = pct + '%';
        }
      }

      // Cart count bubble (theme header)
      const displayCount = itemCount > 99 ? '99+' : (itemCount || '');
      const countEls = document.querySelectorAll('[data-cart-count], .cart-count, .cart-bubble__text-count');
      countEls.forEach((el) => {
        el.textContent = displayCount;
        if (el.classList.contains('cart-bubble__text-count')) {
          el.dataset.cartCountValue = String(itemCount || 0);
          el.classList.toggle('hidden', itemCount === 0);
        }
      });
      document.querySelectorAll('.cart-bubble').forEach((el) => {
        el.classList.toggle('visually-hidden', itemCount === 0);
      });
      document.querySelectorAll('cart-icon').forEach((el) => {
        el.classList.toggle('header-actions__cart-icon--has-cart', itemCount > 0);
      });

      // Empty state
      if (lineCount === 0) {
        const linesContainer = this.querySelector('[data-vc-cart-lines]');
        if (linesContainer) {
          linesContainer.innerHTML = '<div class="vc-empty"><p>Your cart is empty.</p><a href="/collections/all" class="vc-btn-outline" style="display:inline-flex;margin-top:16px;">Browse products</a></div>';
        }
      }

      // Multi-address: update cart cache; re-fetch rates for checked, clear for unchecked
      this._maCartData = cart;
      const maList = document.getElementById('vc-ma-list');
      if (maList) {
        maList.querySelectorAll('.vc-ma-check').forEach(cb => {
          const rateEl = cb.closest('.vc-ma-item')?.querySelector('.vc-ma-item-rate');
          if (!rateEl) return;
          if (cb.checked) {
            rateEl.innerHTML = '';
            this._fetchMaRate(parseInt(cb.dataset.idx), rateEl);
          } else {
            rateEl.innerHTML = '';
          }
        });
      }
    }

    _money(amount) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
    }

    // ── Cricket-Wireless single-address mode ─────────────────
    async _initCricket() {
      const auth = window.__vaAuth;
      if (!auth?.customer_id) return;

      // Hide checkout immediately for B2B customers — restore below if not CRICKET
      const checkoutLink = this.querySelector('#vc-checkout-link');
      if (checkoutLink) checkoutLink.style.display = 'none';

      const customerData = await window.__vaCustomerInfo;
      if (!customerData) { if (checkoutLink) checkoutLink.style.display = ''; return; }

      const market = (customerData.shopifyMarketHandle || customerData.ShopifyMarketHandle || '').toUpperCase();
      if (market !== 'CRICKET-WIRELESS') { if (checkoutLink) checkoutLink.style.display = ''; return; }

      // CRICKET-WIRELESS: keep checkout hidden, show export, hide note toggle
      const exportBtn = this.querySelector('#vc-cricket-export');
      if (exportBtn) exportBtn.hidden = false;
      const noteWrap = this.querySelector('.vc-note-wrap').parentNode;
      if (noteWrap) noteWrap.style.display = 'none';

      // Show shipping section
      const cricketSection = this.querySelector('#vc-cricket-shipping');
      if (cricketSection) cricketSection.hidden = false;

      // Fetch ship-to addresses from BC (same source as ERP address form, so newly added addresses appear immediately)
      let addresses = [];
      try {
        const d = await fetch(auth.proxy, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop, action: 'address-list', include_children: true })
        }).then(r => r.json()).catch(() => null);
        if (d?.ok && d.addresses) addresses = d.addresses;
      } catch (_) {}

      const addrSel = this.querySelector('#vc-cricket-addr-sel');
      if (!addrSel) return;

      if (!addresses.length) {
        addrSel.innerHTML = '<option>No addresses found</option>';
        return;
      }

      addrSel.innerHTML = '';
      addresses.forEach((a, i) => {
        const opt = document.createElement('option');
        opt.value = String(i);
        opt.textContent = (a.code ? '[' + a.code + '] ' : '') + (a.name || '') + (a.city ? ' \u2013 ' + a.city : '');
        addrSel.appendChild(opt);
      });

      // Fetch rates for initial address
      await this._fetchCricketRates(auth, addresses[0]);

      addrSel.addEventListener('change', async () => {
        const idx = parseInt(addrSel.value) || 0;
        await this._fetchCricketRates(auth, addresses[idx]);
      });

      if (exportBtn) {
        exportBtn.addEventListener('click', () => this._exportCricketXLS(addrSel, addresses, customerData));
      }
    }

    async _fetchCricketRates(auth, address) {
      const rateRow   = this.querySelector('#vc-cricket-rate-row');
      const rateCell  = this.querySelector('#vc-cricket-rate-cell');
      const exportBtn = this.querySelector('#vc-cricket-export');
      if (!rateRow || !rateCell) return;
      rateRow.hidden = false;
      rateCell.innerHTML = '<em>Fetching rates\u2026</em>';
      if (exportBtn) exportBtn.dataset.loading = '';

      try {
        if (!address.address || !address.city || !address.postCode) {
          rateCell.innerHTML = '<em>Address incomplete</em>';
          return;
        }

        // Get cart totals
        let subtotal = 0, weight = 0;
        try {
          const r = await fetch('/cart.js');
          const cart = await r.json();
          subtotal = (cart.original_total_price ?? cart.total_price ?? 0) / 100;
          weight   = (cart.items || []).reduce((s, i) => s + (i.grams || 0) * (i.quantity || 0), 0) / 453.592;
        } catch (_) {}

        let data = null;
        try {
          const resp = await fetch(auth.proxy, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop,
              action: 'checkout-options',
              subtotal, weight: weight || 0.01,
              ship_to: {
                name:     address.name     || '',
                address1: address.address  || '',
                address2: address.address2 || '',
                city:     address.city     || '',
                state:    address.county   || '',
                zip:      address.postCode || '',
                country:  address.countryRegionCode || 'US',
                phone:    address.phoneNo  || '',
              }
            })
          });
          const result = await resp.json();
          if (!result.ok) throw new Error(result.error || 'API error');
          data = result.data || {};
        } catch (err) {
          let msg = err.message.replace(/^HTTP \d+ - /, '').replace(/^[^:]+:\s*/, '').replace(/\s*\([^)]+\)\s*$/, '').trim();
          rateCell.innerHTML = '<em>' + msg + '</em>';
          return;
        }

        const rates      = data.rateOptions || [];
        const validRates = rates.filter(r => {
          if (r.errorMessages && r.errorMessages.length > 0) return false;
          const name = (r.serviceDisplayName || ((r.carrierFriendlyName || '') + ' ' + (r.serviceCode || ''))).toLowerCase();
          return !name.includes('pickup');
        });

        if (!validRates.length) {
          rateCell.innerHTML = '<em>No rates available</em>';
          return;
        }

        const select = document.createElement('select');
        select.id = 'vc-cricket-rate-select';
        for (const rate of validRates) {
          const price = rate.buyerFreightChargeLCY ?? rate.amount ?? 0;
          const name  = rate.serviceDisplayName || ((rate.carrierFriendlyName || '') + ' ' + (rate.serviceCode || '')).trim();
          const opt   = document.createElement('option');
          opt.value        = price;
          opt.dataset.erp  = JSON.stringify({ agent: rate.bcShippingAgentCode ?? null, service: rate.bcShippingAgentServiceCode ?? null });
          opt.textContent  = price == 0 ? name + ' - Free Shipping' : name + ' - $' + Number(price).toFixed(2);
          select.appendChild(opt);
        }
        rateCell.innerHTML = '';
        rateCell.appendChild(select);
      } finally {
        if (exportBtn) delete exportBtn.dataset.loading;
      }
    }

    async _exportCricketXLS(addrSel, addresses, customerData) {
      const idx     = parseInt(addrSel.value) || 0;
      const address = addresses[idx];
      // aboUseOwnCustomerNo === true  → use this company's own customerNo
      // aboUseOwnCustomerNo !== true  → use the parent company's customerNo (fallback to own)
      const ownNo    = customerData.No || customerData.no || '';
      const parentNo = customerData.parentCustomerNo || '';
      const erpNo    = customerData.aboUseOwnCustomerNo ? (ownNo || parentNo) : (parentNo || ownNo);

      const SHIP_VIA_MAP = [
        ['Pick-Up',           'PICK-UP', 'PICK-UP'],
        ['Ground Shipping',   'FEDEX',   'GND'],
        ['Next-Day Shipping', 'FEDEX',   '1DP'],
        ['2-Day Shipping',    'FEDEX',   '2DA'],
        ['3-Day Shipping',    'FEDEX',   '3DS'],
      ];
      const resolveShipVia = (agent, service) => {
        for (const [out, a, s] of SHIP_VIA_MAP)
          if (agent === a && service === s) return out;
        return agent && service ? agent + ' ' + service : agent || service || '';
      };

      let shipVia = '';
      const rateSel = this.querySelector('#vc-cricket-rate-select');
      if (rateSel) {
        let erp = {};
        try { erp = JSON.parse(rateSel.options[rateSel.selectedIndex]?.dataset.erp || '{}'); } catch (_) {}
        shipVia = resolveShipVia(erp.agent || '', erp.service || '');
      }

      let items = [];
      try {
        const r = await fetch('/cart.js');
        const cart = await r.json();
        items = cart.items || [];
      } catch (_) {}

      const vendorId  = '2012';
      const shipToCode = address.code || address.bcShipToCode || '';
      const acctId    = erpNo;

      // Order rows for the template's "Order Details" sheet (its header is already row 1).
      const dataRows = [];
      for (const item of items) {
        if (!item.quantity) continue;
        dataRows.push([shipToCode, vendorId, item.sku || '', item.quantity, shipVia, acctId, '']);
      }
      if (!dataRows.length) return;

      // Load the customer-provided template (base64 in a theme asset) and JSZip on demand.
      if (!window.__vcExportTemplateB64) {
        const tplUrl = this.dataset.exportTemplateUrl;
        if (!tplUrl) { vcAlert('Export template is unavailable. Please try again later.'); return; }
        await new Promise((resolve, reject) => {
          const s = document.createElement('script');
          s.src = tplUrl; s.onload = resolve; s.onerror = reject;
          document.head.appendChild(s);
        });
      }
      if (!window.JSZip) {
        await new Promise((resolve, reject) => {
          const s = document.createElement('script');
          s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js';
          s.onload = resolve;
          s.onerror = reject;
          document.head.appendChild(s);
        });
      }

      // xlsx is a zip of XML parts. Inject rows into Order Details (sheet1.xml) only —
      // styles, sharedStrings, and the Vendor Information sheet stay byte-identical, so the
      // customer's exact display format is preserved.
      const bin = atob(window.__vcExportTemplateB64);
      const bytes = new Uint8Array(bin.length);
      for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);

      const xmlEsc = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      let rowsXml = '';
      let rowNum = 2; // header occupies row 1
      for (const row of dataRows) {
        let cells = '';
        for (let ci = 0; ci < row.length; ci++) {
          const ref = String.fromCharCode(65 + ci) + rowNum;
          const val = row[ci];
          if (typeof val === 'number') {
            cells += '<c r="' + ref + '"><v>' + val + '</v></c>';
          } else if (val !== '' && val != null) {
            cells += '<c r="' + ref + '" t="inlineStr"><is><t>' + xmlEsc(val) + '</t></is></c>';
          }
        }
        rowsXml += '<row r="' + rowNum + '" spans="1:7">' + cells + '</row>';
        rowNum++;
      }
      const lastRow = rowNum - 1;

      const zip = await window.JSZip.loadAsync(bytes);

      // Order Details (sheet1): inject the order rows, bump the dimension, and mark it the
      // selected tab so the workbook opens on it (the template ships with Vendor Info active).
      const sheetPath = 'xl/worksheets/sheet1.xml';
      let sheetXml = await zip.file(sheetPath).async('string');
      sheetXml = sheetXml
        .replace('</sheetData>', rowsXml + '</sheetData>')
        .replace('<dimension ref="A1:G1"/>', '<dimension ref="A1:G' + lastRow + '"/>')
        .replace('<sheetView workbookViewId="0">', '<sheetView tabSelected="1" workbookViewId="0">');
      zip.file(sheetPath, sheetXml);

      // workbook.xml: point the active tab at the first sheet.
      if (zip.file('xl/workbook.xml')) {
        const wbXml = (await zip.file('xl/workbook.xml').async('string')).replace(/activeTab="\d+"/, 'activeTab="0"');
        zip.file('xl/workbook.xml', wbXml);
      }
      // Vendor Information (sheet2): clear its selected-tab flag so it isn't the active tab.
      if (zip.file('xl/worksheets/sheet2.xml')) {
        const s2Xml = (await zip.file('xl/worksheets/sheet2.xml').async('string')).replace(' tabSelected="1"', '');
        zip.file('xl/worksheets/sheet2.xml', s2Xml);
      }

      const blob = await zip.generateAsync({
        type: 'blob',
        compression: 'DEFLATE',
        mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const dlUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = dlUrl; a.download = 'cart-export.xlsx';
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(dlUrl), 1000);
    }

    // ── Saved carts ───────────────────────────────────────
    _initSavedCarts() {
      const auth = window.__vaAuth;
      if (!auth?.customer_id) return;

      const saveBtn  = this.querySelector('[data-vc-save-cart]');
      const loadBtn  = this.querySelector('[data-vc-load-saved]');
      if (saveBtn) saveBtn.hidden = false;
      if (loadBtn) loadBtn.hidden = false;

      // ── Save modal ──
      const saveModal    = document.getElementById('vc-save-modal');
      const saveInput    = document.getElementById('vc-save-name');
      const saveConfirm  = document.getElementById('vc-save-confirm');
      const saveCancel   = document.getElementById('vc-save-cancel');
      const saveErr      = document.getElementById('vc-save-err');
      const saveHint     = document.getElementById('vc-save-hint');
      const saveHintName = document.getElementById('vc-save-hint-name');
      let saveKnownNames = [];

      function saveCheckDuplicate() {
        const val = saveInput.value.trim();
        if (val && saveKnownNames.includes(val.toLowerCase())) {
			if (saveHintName)
	          saveHintName.textContent = val;
          saveHint.hidden = false;
        } else {
          saveHint.hidden = true;
        }
      }

      if (saveBtn && saveModal) {
        saveBtn.addEventListener('click', () => {
          saveInput.value = '';
          saveErr.hidden = true;
          saveHint.hidden = true;
          saveKnownNames = [];
          saveModal.hidden = false;
          saveInput.focus();
          // Background fetch of existing cart names for duplicate check
          if (auth.proxy && auth.customer_id) {
            fetch(auth.proxy, {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop, action: 'saved-carts-list', scope: 'mine' }),
            }).then(r => r.json()).then(d => {
              if (d.ok) {
                saveKnownNames = (d.carts || []).map(c => c.name.toLowerCase());
                saveCheckDuplicate();
              }
            }).catch(() => {});
          }
        });
        saveCancel.addEventListener('click', () => { saveModal.hidden = true; });
        saveModal.addEventListener('click', (e) => { if (e.target === saveModal) saveModal.hidden = true; });
        saveInput.addEventListener('input', saveCheckDuplicate);
        saveInput.addEventListener('keydown', (e) => { if (e.key === 'Enter') saveConfirm.click(); });

        saveConfirm.addEventListener('click', async () => {
          const name = saveInput.value.trim();
          if (!name) { saveErr.textContent = 'Please enter a name.'; saveErr.hidden = false; return; }
          saveConfirm.disabled = true;
          saveConfirm.textContent = 'Saving…';
          saveErr.hidden = true;
          try {
            const cart = await fetch('/cart.js').then((r) => r.json());
            const items = (cart.items || []).map((i) => ({
              variant_id: i.variant_id,
              handle:     i.handle || '',
              qty:        i.quantity,
              title:      i.product_title || i.title,
              sku:        i.sku || '',
              image:      i.image || '',
              price:      i.final_price,
            }));
            const r = await fetch(auth.proxy, {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop, action: 'saved-carts-save', name, items }),
            });
            const d = await r.json();
            if (!d.ok) throw new Error(d.error || 'Save failed');
            saveHint.hidden = true;
            saveModal.hidden = true;
          } catch (err) {
            saveErr.textContent = err.message || 'Save failed.';
            saveErr.hidden = false;
          } finally {
            saveConfirm.disabled = false;
            saveConfirm.textContent = 'Save';
          }
        });
      }

      // ── Load modal ──
      const loadModal    = document.getElementById('vc-load-modal');
      const loadList     = document.getElementById('vc-load-list');
      const loadClose    = document.getElementById('vc-load-close');
      const loadScopeEl  = document.getElementById('vc-load-scope');
      const loadPager    = document.getElementById('vc-load-pager');
      const LD_PER_PAGE  = 8;
      const ldState      = { allCarts: [], page: 1, scope: 'mine', isParentCompany: false };

      function ldEsc(s) {
        return String(s).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
      }

      function ldBuildItems(items) {
        const fmtP = (c) => c == null ? '\u2014' : '$' + (c / 100).toFixed(2);
        return '<div class="vc-sc-items">' + (items || []).map(item => {
          const img = item.image ? `<img src="${ldEsc(item.image)}" alt="" loading="lazy">` : '';
          const sku = item.sku ? 'SKU: ' + ldEsc(item.sku) : '';
          const handle = item.handle ? ldEsc(item.handle) : '';
          return `<div class="vc-sc-item"${handle ? ` data-qv-handle="${handle}"` : ''}><div class="vc-sc-item-img">${img}</div><div class="vc-sc-item-info"><div class="vc-sc-item-title">${ldEsc(item.title || 'Unknown')}</div>${sku ? `<div class="vc-sc-item-sku">${sku}</div>` : ''}</div><div class="vc-sc-item-right"><div class="vc-sc-item-qty">\u00d7${item.qty || 0}</div><div class="vc-sc-item-price">${fmtP(item.price)}</div></div></div>`;
        }).join('') + '</div>';
      }

      async function ldFetch() {
        if (!loadList) return;
        loadList.innerHTML = '<div class="vc-sc-empty">Loading\u2026</div>';
        if (loadPager) loadPager.hidden = true;
        try {
          const r = await fetch(auth.proxy, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop, action: 'saved-carts-list', scope: ldState.scope }),
          });
          const d = await r.json();
          if (!d.ok) throw new Error(d.error || 'Failed to load');
          ldState.allCarts = d.carts || [];
          ldState.isParentCompany = !!d.is_parent_company;
          ldState.page = 1;
          ldRender();
        } catch (err) {
          loadList.innerHTML = `<div class="vc-sc-empty">${err.message || 'Failed to load saved carts.'}</div>`;
        }
      }

      function ldRender() {
        const total = ldState.allCarts.length;
        const pages = Math.max(1, Math.ceil(total / LD_PER_PAGE));
        if (ldState.page > pages) ldState.page = pages;
        const start = (ldState.page - 1) * LD_PER_PAGE;
        const page  = ldState.allCarts.slice(start, start + LD_PER_PAGE);
        const chevron = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>';
        const showOwner = ldState.scope === 'org' && page.some(c => c.owner_name);
        const ownerCls  = showOwner ? ' has-owner' : '';
        if (!total) {
          loadList.innerHTML = '<div class="vc-sc-empty">No saved carts yet.</div>';
          if (loadPager) loadPager.hidden = true;
          return;
        }
        const header = `<div class="vc-sc-row-head${ownerCls}">
          <div>Name</div>
          ${showOwner ? '<div>Company</div>' : ''}
          <div>Items</div>
          <div>Saved</div>
          <div></div>
          <div></div>
        </div>`;
        loadList.innerHTML = header + page.map((c, i) => {
          const safeName = ldEsc(c.name);
          const ownerErp = ldEsc(c.owner_erp_no || '');
          const isMine   = !c.owner_name;
          const count    = c.item_count;
          const date     = new Date(c.saved_at).toLocaleDateString();
          const panelId  = `vc-ld-panel-${start + i}`;
          const previews = (c.previews || []).map(src => `<img class="vc-sc-preview-img" src="${ldEsc(src)}" alt="" loading="lazy">`).join('');
          return `<div class="vc-sc-row${ownerCls}" data-sc-name="${safeName}" data-sc-erp="${ownerErp}">
            <div class="vc-sc-row-name-col">
              <div class="vc-sc-row-name">${safeName}</div>
              ${previews ? `<div class="vc-sc-preview-wrap">${previews}</div>` : ''}
            </div>
            ${showOwner ? `<div class="vc-sc-row-owner">${c.owner_name ? ldEsc(c.owner_name) : '<span style="font-style:italic">My company</span>'}</div>` : ''}
            <div class="vc-sc-row-meta">${count} line item${count != 1 ? 's' : ''}</div>
            <div class="vc-sc-row-date">${date}</div>
            <div class="vc-sc-row-actions">
              ${(isMine || ldState.isParentCompany) ? `<button class="vc-sc-txt-btn danger" data-sc-del>Delete</button>` : ''}
              <button class="vc-sc-txt-btn" data-sc-load>Load</button>
            </div>
            <button class="vc-sc-expand-btn" data-sc-expand="${panelId}" title="Show items">${chevron}</button>
            <div class="vc-sc-detail" id="${panelId}">
              <div class="vc-sc-detail-inner"></div>
            </div>
          </div>`;
        }).join('');
        const pg = ldState.page;
        const showPager = pages > 1;
        const pHtml = `<button class="vc-sc-pager-btn" id="vc-ld-prev" ${pg <= 1 ? 'disabled' : ''}>\u2190 Prev</button><span class="vc-sc-pager-info">Page ${pg} of ${pages}</span><button class="vc-sc-pager-btn" id="vc-ld-next" ${pg >= pages ? 'disabled' : ''}>Next \u2192</button>`;
        if (loadPager) { loadPager.innerHTML = pHtml; loadPager.hidden = !showPager; }
      }

      if (loadBtn && loadModal) {
        loadBtn.addEventListener('click', () => { loadModal.hidden = false; ldFetch(); });

        if (loadScopeEl) {
          loadScopeEl.addEventListener('click', (e) => {
            const btn = e.target.closest('.vc-sc-scope-btn');
            if (!btn || btn.dataset.scope === ldState.scope) return;
            ldState.scope = btn.dataset.scope;
            loadScopeEl.querySelectorAll('.vc-sc-scope-btn').forEach(b => b.classList.toggle('vc-sc-scope-btn--active', b === btn));
            ldFetch();
          });
          // Hidden by default (see markup); reveal only for stores that have child
          // locations, so there's no flash for leaf/standalone stores.
          window.__vaCustomerInfo && window.__vaCustomerInfo.then((info) => {
            if (info && (info.childCount || 0) > 0) loadScopeEl.hidden = false;
          });
        }

        // Delegated click handler — registered once to avoid stacking listeners.
        loadList.addEventListener('click', async (e) => {
          const qvItem = e.target.closest('[data-qv-handle]');
          if (qvItem && !e.target.closest('button')) {
            const handle = qvItem.dataset.qvHandle;
            if (handle && window.openQuickViewDialog) {
              window.openQuickViewDialog(`/products/${handle}?view=valor-quick-add`);
            }
            return;
          }

          const expandBtn = e.target.closest('[data-sc-expand]');
          if (expandBtn) {
            const panelId = expandBtn.dataset.scExpand;
            const panel   = document.getElementById(panelId);
            if (!panel) return;
            const isOpen  = panel.classList.contains('open');
            loadList.querySelectorAll('.vc-sc-detail.open').forEach(p => p.classList.remove('open'));
            loadList.querySelectorAll('.vc-sc-expand-btn.open').forEach(b => b.classList.remove('open'));
            if (!isOpen) {
              panel.classList.add('open');
              expandBtn.classList.add('open');
              if (!panel.dataset.loaded) {
                const inner    = panel.querySelector('.vc-sc-detail-inner');
                const row      = panel.closest('[data-sc-name]');
                const cartName = row.dataset.scName;
                const cartErp  = row.dataset.scErp || '';
                inner.innerHTML = '<div style="padding:8px 0;font-size:12px;color:var(--vc-steel,#64748b)">Loading\u2026</div>';
                try {
                  const r = await fetch(auth.proxy, {
                    method: 'POST', headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop, action: 'saved-carts-load', name: cartName, owner_erp_no: cartErp }),
                  });
                  const d = await r.json();
                  panel.dataset.loaded = '1';
                  inner.innerHTML = (d.ok && d.items && d.items.length) ? ldBuildItems(d.items) : '<div style="padding:8px 0;font-size:12px;color:var(--vc-steel,#64748b)">No items.</div>';
                } catch (_) {
                  inner.innerHTML = '<div style="padding:8px 0;font-size:12px;color:var(--vc-steel,#64748b)">Could not load items.</div>';
                }
              }
            }
            return;
          }
          const row = e.target.closest('[data-sc-name]');
          if (!row) return;
          const name     = row.getAttribute('data-sc-name');
          const ownerErp = row.getAttribute('data-sc-erp') || '';
          if (e.target.closest('[data-sc-load]')) {
            await this._doLoadCart(name, ownerErp, auth, loadModal);
          } else if (e.target.closest('.vc-sc-detail')) {
            // click inside expanded detail — do nothing
          } else if (e.target.closest('[data-sc-del]')) {
            const delBtn = e.target.closest('[data-sc-del]');
            const ok = await vcConfirm(`Delete "${name}"?`, 'Delete', true);
            if (!ok) return;
            delBtn.disabled = true;
            try {
              const r = await fetch(auth.proxy, {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop, action: 'saved-carts-delete', name, owner_erp_no: ownerErp }),
              });
              const d = await r.json();
              if (!d.ok) throw new Error(d.error || 'Delete failed');
              ldState.allCarts = ldState.allCarts.filter(c => !(c.name === name && (c.owner_erp_no || '') === ownerErp));
              ldRender();
            } catch (err) {
              vcAlert(err.message || 'Delete failed.');
              delBtn.disabled = false;
            }
          } else {
            const btn = row.querySelector('.vc-sc-expand-btn[data-sc-expand]');
            if (btn) btn.click();
          }
        });

        loadClose.addEventListener('click', () => { loadModal.hidden = true; });
        loadModal.addEventListener('click', (e) => {
          if (e.target.id === 'vc-ld-prev') { if (ldState.page > 1) { ldState.page--; ldRender(); } }
          else if (e.target.id === 'vc-ld-next') { ldState.page++; ldRender(); }
          else if (e.target === loadModal) { loadModal.hidden = true; }
        });
      }

      // Auto-load a cart if navigated here from the account page
      const pending = (() => { try { return sessionStorage.getItem('vc_load_cart'); } catch (_) { return null; } })();
      if (pending) {
        try { sessionStorage.removeItem('vc_load_cart'); } catch (_) {}
        let cartName = pending, ownerErp = '';
        try { const p = JSON.parse(pending); cartName = p.name; ownerErp = p.ownerErp || ''; } catch (_) {}
        this._doLoadCart(cartName, ownerErp, auth, null);
      }
    }

    async _doLoadCart(name, ownerErp, auth, modal) {
      const ok = await vcConfirm(`Load "${name}"? This will replace your current cart.`, 'Load cart', false);
      if (!ok) return;
      const busy = vcShowBusy('Checking availability…');
      try {
        const body = { customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop, action: 'saved-carts-load', name };
        if (ownerErp) body.owner_erp_no = ownerErp;
        const r = await fetch(auth.proxy, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        });
        const d = await r.json();
        if (!d.ok) throw new Error(d.error || 'Load failed');
        const requested = d.items || [];
        if (!requested.length) throw new Error('This saved cart has no items.');

        // Validate availability BEFORE clearing the live cart, so unavailable items
        // (deleted / out of stock / insufficient qty) don't cause an atomic /cart/add.js
        // to fail the whole batch and leave the cart empty.
        let items = requested;
        const skipped = [];
        try {
          const vr = await fetch(auth.proxy, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop,
              action: 'saved-carts-validate', variant_ids: requested.map((it) => it.variant_id),
            }),
          }).then((res) => res.json());
          if (vr && vr.ok && vr.variants) {
            const good = [];
            requested.forEach((it) => {
              const info = vr.variants[String(it.variant_id)];
              const max  = info ? info.maxQty : 0; // no entry => not purchasable
              if (max === null || (typeof max === 'number' && max >= it.qty)) good.push(it);
              else skipped.push(it);
            });
            items = good;
          }
        } catch (_) { /* validation unavailable — fall back to resilient add below */ }

        if (!items.length) {
          busy.hide();
          if (modal) modal.hidden = true;
          await vcAlert(`None of the items in "${name}" are currently available, so your cart was left unchanged.`);
          return;
        }

        busy.setText('Updating your cart…');
        await fetch('/cart/clear.js', { method: 'POST' });

        // Add items in chunks of 25. If a batch is still rejected (e.g. validation was
        // unavailable, or stock changed since), retry that chunk one item at a time so a
        // single bad variant can't drop the other 24.
        let addFailed = 0;
        for (let i = 0; i < items.length; i += 25) {
          const chunk = items.slice(i, i + 25);
          const res = await fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: chunk.map((it) => ({ id: it.variant_id, quantity: it.qty })) }),
          });
          if (!res.ok) {
            for (const it of chunk) {
              const one = await fetch('/cart/add.js', {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: it.variant_id, quantity: it.qty }] }),
              });
              if (!one.ok) { skipped.push(it); addFailed++; }
            }
          }
        }

        busy.hide();
        if (modal) modal.hidden = true;
        const loaded = items.length - addFailed;
        if (skipped.length) {
          const names = skipped.map((it) => '• ' + (it.title || it.sku || it.variant_id)).join('\n');
          await vcAlert(`Loaded ${loaded} of ${requested.length} items.\n${skipped.length} unavailable and skipped:\n\n${names}`);
        }
        location.reload();
      } catch (err) {
        busy.hide();
        vcAlert(err.message || 'Failed to load cart.');
      }
    }

    // ── Spendback store credit ────────────────────────────
    async _initStoreCredit() {
      const auth = window.__vaAuth;
      if (!auth?.customer_id) return;

      const customerData = await window.__vaCustomerInfo;
      const market = (customerData?.shopifyMarketHandle || customerData?.ShopifyMarketHandle || '').toUpperCase();
      if (market !== 'CRICKET-WIRELESS') return;
      if ((customerData?.No || customerData?.no || '') !== 'C0000105') return;

      const cart = await fetch('/cart.js').then(r => r.json()).catch(() => null);
      const orderTotal = cart ? ((cart.original_total_price ?? cart.total_price) / 100).toFixed(2) : null;

      const reqBody = {
        customer_id: auth.customer_id, ts: auth.ts, token: auth.token,
        shop: Shopify.shop, action: 'store-credit-quote',
      };
      if (orderTotal) reqBody.order_total = orderTotal;

      const d = await fetch(auth.proxy, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(reqBody),
      }).then(r => r.json()).catch(() => null);

      if (!d?.ok || !d.data) return;
      const sc = d.data;

      const availEl = this.querySelector('[data-vc-sc-available]');
      const maxEl   = this.querySelector('[data-vc-sc-max]');

      if (availEl) availEl.textContent = this._money(parseFloat(sc.available));
      if (maxEl) maxEl.textContent = this._money(parseFloat(sc.maxApplicable));

      const wrap = this.querySelector('#vc-spendback-wrap');
      if (wrap) wrap.style.display = '';
      const nextWrap = this.querySelector('#vc-sc-next-wrap');
      if (nextWrap) nextWrap.style.display = '';
    }

    // ── Multi-address checkout ────────────────────────────
    async _initMultiAddr() {
      const auth = window.__vaAuth;
      if (!auth?.customer_id) return;

      // CRICKET-WIRELESS customers use the export flow instead of multi-location
      // copy — skip building the multi-addr UI so #vc-ma-trigger stays hidden.
      const customerData = await window.__vaCustomerInfo;
      const market = (customerData?.shopifyMarketHandle || customerData?.ShopifyMarketHandle || '').toUpperCase();
      if (market === 'CRICKET-WIRELESS') return;

      const [res, cartData] = await Promise.all([
        fetch(auth.proxy, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            customer_id: auth.customer_id, ts: auth.ts, token: auth.token,
            shop: Shopify.shop, action: 'address-list', include_children: true,
          }),
        }).then(r => r.json()).catch(() => null),
        fetch('/cart.js').then(r => r.json()).catch(() => null),
      ]);

      if (!res?.ok || !res.addresses || res.addresses.length < 2) return;

      // Reuse this cart snapshot for rate lookups, the Order Preview scaling,
      // and (below) restoring which locations were selected before a refresh.
      this._maCartData = cartData;

      this._maAddresses = res.addresses.map(a => ({
        id:           a.code              || '',
        bcSystemId:   a.systemId          || '',
        bcCustomerNo: a.bcCustomerNo      || a.customerNo || '',
        bcShipToCode: a.bcShipToCode      || a.code       || '',
        name:         a.name              || '',
        contact:      a.contact           || '',
        addr:         [a.address, a.city, a.county, a.postCode].filter(Boolean).join(', '),
        address1:     a.address           || '',
        address2:     a.address2          || '',
        city:         a.city              || '',
        state:        a.county            || '',
        zip:          a.postCode          || '',
        country:      a.countryRegionCode || '',
        phone:        a.phoneNo           || '',
      }));

      const esc = s => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

      const list = document.getElementById('vc-ma-list');
      if (list) {
        list.innerHTML = this._maAddresses.map((a, i) => `
          <label class="vc-ma-item">
            <input type="checkbox" class="vc-ma-check" data-idx="${i}">
            <span class="vc-ma-item-body">
              <span class="vc-ma-item-name">${esc(a.name)}</span>
              ${a.bcShipToCode ? `<span class="vc-ma-item-code">${esc(a.bcShipToCode)}</span>` : ''}
              ${a.addr ? `<span class="vc-ma-item-addr">${esc(a.addr)}</span>` : ''}
            </span>
            <span class="vc-ma-item-rate"></span>
          </label>
        `).join('');

        list.addEventListener('change', (e) => {
          const cb = e.target.closest('.vc-ma-check');
          if (!cb) return;
          const n = list.querySelectorAll('.vc-ma-check:checked').length;
          const countEl = document.getElementById('vc-ma-sel-count');
          if (countEl) countEl.textContent = String(n);
          const btn = document.getElementById('vc-ma-submit');
          if (btn) btn.disabled = n < 1;
          const rateEl = cb.closest('.vc-ma-item')?.querySelector('.vc-ma-item-rate');
          if (cb.checked && rateEl && !rateEl.children.length) {
            this._fetchMaRate(parseInt(cb.dataset.idx), rateEl);
          }
          this._updateMaSummary(n);
          this._saveMaSelection();
        });

        // Restore locations selected before a page refresh, from the cart attribute.
        // Just re-check the boxes — the Order Preview stays on the real single-location
        // cart totals until the user actually opens the multi-location view (openView()
        // scales it from the checked count at that point).
        let savedIds = [];
        try {
          savedIds = JSON.parse(this._maCartData?.attributes?._locations || '[]');
        } catch (_) {}
        if (Array.isArray(savedIds) && savedIds.length) {
          const restored = [];
          list.querySelectorAll('.vc-ma-check').forEach((cb) => {
            const addr = this._maAddresses[parseInt(cb.dataset.idx)];
            if (addr && savedIds.includes(addr.id)) {
              cb.checked = true;
              restored.push(cb);
            }
          });
          if (restored.length) {
            const n = restored.length;
            const countEl = document.getElementById('vc-ma-sel-count');
            if (countEl) countEl.textContent = String(n);
            const btn = document.getElementById('vc-ma-submit');
            if (btn) btn.disabled = n < 1;
            restored.forEach((cb) => {
              const rateEl = cb.closest('.vc-ma-item')?.querySelector('.vc-ma-item-rate');
              if (rateEl) this._fetchMaRate(parseInt(cb.dataset.idx), rateEl);
            });
          }
        }
      }

      // Trigger button opens the multi-addr view
      const trigger   = document.getElementById('vc-ma-trigger');
      const cartLines = this.querySelector('[data-vc-cart-lines]');
      const maView    = document.getElementById('vc-ma-view');
      const submitBtn = document.getElementById('vc-ma-submit');
      const checkoutBtn = document.getElementById('vc-checkout-link');

      const openView = () => {
        if (cartLines) cartLines.hidden = true;
        if (maView)    maView.hidden    = false;
        if (trigger) {
          trigger.classList.add('vc-ma-trigger--open');
          const lbl = trigger.querySelector('.vc-ma-trigger__label');
          if (lbl) lbl.textContent = 'Modify cart items';
        }
        if (submitBtn)   submitBtn.hidden   = false;
        if (checkoutBtn) checkoutBtn.hidden = true;
        const n = maView?.querySelectorAll('.vc-ma-check:checked').length || 0;
        this._updateMaSummary(n);
      };
      const closeView = () => {
        if (cartLines) cartLines.hidden = false;
        if (maView)    maView.hidden    = true;
        if (trigger) {
          trigger.classList.remove('vc-ma-trigger--open');
          const lbl = trigger.querySelector('.vc-ma-trigger__label');
          if (lbl) lbl.textContent = 'Copy to multiple locations';
        }
        if (submitBtn)   submitBtn.hidden   = true;
        if (checkoutBtn) checkoutBtn.hidden = false;
        this._updateMaSummary(0);
      };

      trigger?.addEventListener('click', () => maView.hidden ? openView() : closeView());
      submitBtn?.addEventListener('click', () => this._submitMultiAddr());

      // Show the trigger button
      if (trigger) trigger.hidden = false;
    }

    // Scale the Order Preview stats/totals by the number of selected locations —
    // each selected location receives a full copy of the cart (see _submitMultiAddr).
    async _updateMaSummary(n) {
      if (!this._maCartData) {
        try {
          this._maCartData = await fetch('/cart.js').then((r) => r.json());
        } catch (_) { return; }
      }
      const cart = this._maCartData;
      const mult = Math.max(n, 1);

      const lineCount    = cart.items ? cart.items.length : 0;
      const baseUnits    = cart.item_count ?? 0;
      const baseOriginal = cart.original_total_price ?? 0;
      const baseItemsSub = cart.items_subtotal_price ?? baseOriginal;

      const itemCount = baseUnits * mult;
      const original  = baseOriginal * mult;
      const itemsSub  = baseItemsSub * mult;
      const discount  = original - itemsSub;

      const statLines = this.querySelector('[data-vc-stat-lines]');
      if (statLines) statLines.textContent = lineCount;
      const statUnits = this.querySelector('[data-vc-stat-units]');
      if (statUnits) statUnits.textContent = itemCount.toLocaleString('en-US');

      const subDisplay = this.querySelector('[data-vc-subtotal-display]');
      if (subDisplay) subDisplay.textContent = this._money(original / 100);
      const savingsRow     = this.querySelector('[data-vc-savings-row]');
      const savingsDisplay = this.querySelector('[data-vc-savings-display]');
      if (savingsRow) savingsRow.hidden = discount <= 0;
      if (savingsDisplay) savingsDisplay.textContent = '−' + this._money(discount / 100);
      const grandTotal = this.querySelector('[data-vc-grand-total]');
      if (grandTotal) grandTotal.textContent = this._money(itemsSub / 100);
    }

    // Persist the checked locations to a cart attribute so they survive a page refresh.
    _saveMaSelection() {
      clearTimeout(this._maSaveTimeout);
      this._maSaveTimeout = setTimeout(() => {
        const selectedIds = Array.from(document.querySelectorAll('.vc-ma-check:checked'))
          .map((cb) => this._maAddresses?.[parseInt(cb.dataset.idx)]?.id)
          .filter(Boolean);
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { _locations: JSON.stringify(selectedIds) } }),
        }).catch(() => {});
      }, 400);
    }

    async _submitMultiAddr() {
      const btn = document.getElementById('vc-ma-submit');
      if (btn) btn.dataset.loading = '';
      try {
        const cart = await fetch('/cart.js').then(r => r.json());

        // Build variantId → qty and variantId → line item hash maps
        const items = {};
        const lineitems = {};
        cart.items.forEach(item => {
          items[String(item.variant_id)] = item.quantity;
          const colon = item.key.indexOf(':');
          if (colon !== -1) lineitems[String(item.variant_id)] = item.key.slice(colon + 1);
        });

        const selected = [];
        document.querySelectorAll('.vc-ma-check:checked').forEach(cb => {
          const addr = this._maAddresses[parseInt(cb.dataset.idx)];
          const rateSelect = cb.closest('.vc-ma-item')?.querySelector('.vc-ma-rate-select');
          let erp = {};
          if (rateSelect) try { erp = JSON.parse(rateSelect.options[rateSelect.selectedIndex]?.dataset.erp || '{}'); } catch(_) {}
          selected.push({ addr, erp });
        });
        if (selected.length < 1) return;

        // Resolve per-address base quantities. _maCartData holds the cart snapshot from
        // when rates were fetched — before any scaling.
        let baseItems = { ...items };
        if (this._maCartData?.items) {
          const base = {};
          this._maCartData.items.forEach(i => { base[String(i.variant_id)] = i.quantity; });
          if (Object.keys(base).every(vid => vid in items)) baseItems = base;
        }

        // Inventory check using base (per-address) quantities
        const shortages = [];
        document.querySelectorAll('[data-vc-line][data-inventory]').forEach(line => {
          const key    = line.getAttribute('data-key');
          const maxInv = parseInt(line.getAttribute('data-inventory'), 10);
          const cartItem = cart.items.find(i => i.key === key);
          if (!cartItem || isNaN(maxInv)) return;
          const vid   = String(cartItem.variant_id);
          const total = (baseItems[vid] ?? cartItem.quantity) * selected.length;
          if (total > maxInv) {
            shortages.push({
              title:     cartItem.product_title || cartItem.title,
              variant:   cartItem.variant_title && cartItem.variant_title !== 'Default Title' ? cartItem.variant_title : '',
              requested: total,
              available: maxInv,
            });
          }
        });
        if (shortages.length) {
          if (btn) delete btn.dataset.loading;
          const proceed = await this._showMaShortageDialog(shortages);
          if (!proceed) return;
          if (btn) btn.dataset.loading = '';
        }

        // Same _order structure as cart-distribution — one entry per address, full cart items each
        const orderAttr = selected.map(({ addr: a, erp }) => ({
          id:          a.bcSystemId   || a.id,
          ...erp,
          bc_customer: a.bcCustomerNo || '',
          bc_ship_to:  a.bcShipToCode || '',
          addr:        a.addr         || '',
          contact:     { name: a.contact || '', phone: a.phone || '' },
          items:       { ...baseItems },
        }));
        const addressAttr = selected.map(({ addr: a }) => ({
          id:          a.bcSystemId   || a.id,
          bc_customer: a.bcCustomerNo || '',
          bc_ship_to:  a.bcShipToCode || '',
          company:     a.name         || '',
          address:     a.address1     || '',
          address2:    a.address2     || '',
          city:        a.city         || '',
          contact:     a.contact      || '',
          phone:       a.phone        || '',
          country:     a.country      || '',
          zip:         a.zip          || '',
          state:       a.state        || '',
        }));

        // Scale cart quantities: each variant × number of selected addresses
        const updates = {};
        Object.entries(baseItems).forEach(([vid, qty]) => { updates[vid] = qty * selected.length; });

        // Save pre-calculated shipping total BEFORE cart update so the file is present
        // when Shopify calls the carrier service in response to the cart quantity change.
        const auth = window.__vaAuth;
        if (auth) {
          const variantKey = Object.entries(updates)
            .filter(([, qty]) => qty > 0)
            .map(([vid, qty]) => `${vid}:${qty}`)
            .sort()
            .join(',');
          const totalShippingCents = Math.round(
            selected.reduce((s, { erp }) => s + (erp.buyer ?? 0), 0) * 100
          );
          await fetch(auth.proxy, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              customer_id:    auth.customer_id,
              ts:             auth.ts,
              token:          auth.token,
              shop:           Shopify.shop,
              action:         'save-shipping-total',
              variant_key:    variantKey,
              shipping_total: totalShippingCents,
            }),
          });
        }

        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            updates,
            attributes: {
              '_order':     JSON.stringify(orderAttr),
              '_address':   JSON.stringify(addressAttr),
              '_lineitems': JSON.stringify(lineitems),
            },
          }),
        });

        // For 1 address: pre-fill the checkout shipping address with the selected address.
        // This changes the destination Shopify uses for carrier rate lookup, busting the
        // shipping rate cache that would otherwise serve stale rates (cart quantities are
        // unchanged for ×1, so Shopify wouldn't re-request rates on its own).
        if (btn) delete btn.dataset.loading;
        if (selected.length === 1) {
          const a = selected[0].addr;
          const p = new URLSearchParams();
          if (a.name)     p.set('checkout[shipping_address][company]',    a.name);
          if (a.contact)  p.set('checkout[shipping_address][first_name]', a.contact);
          if (a.address1) p.set('checkout[shipping_address][address1]',   a.address1);
          if (a.address2) p.set('checkout[shipping_address][address2]',   a.address2);
          if (a.city)     p.set('checkout[shipping_address][city]',       a.city);
          if (a.state)    p.set('checkout[shipping_address][province]',   a.state);
          if (a.zip)      p.set('checkout[shipping_address][zip]',        a.zip);
          p.set('checkout[shipping_address][country]', a.country || 'US');
          if (a.phone)    p.set('checkout[shipping_address][phone]',      a.phone);
          window.location.href = '/checkout?' + p.toString();
        } else {
          window.location.href = '/checkout';
        }
      } catch (err) {
        if (btn) delete btn.dataset.loading;
        vcAlert(err.message || 'Failed to prepare multi-address order.');
      }
    }

    _showMaShortageDialog(shortages) {
      return new Promise(resolve => {
        const overlay = document.createElement('div');
        overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.35);z-index:9999;display:flex;align-items:center;justify-content:center;';
        const listHtml = shortages.map(s => {
          const label = [s.title, s.variant].filter(Boolean).join(' \u2013 ');
          return `<li><strong>${label}</strong>: ${s.requested} needed, ${s.available} available</li>`;
        }).join('');
        overlay.innerHTML = `
          <div style="background:#fff;border-radius:12px;padding:24px;max-width:420px;width:90%;box-shadow:0 8px 32px rgba(0,0,0,0.18);">
            <h3 style="margin:0 0 10px;font-size:16px;font-weight:600;color:#1D2636;">Insufficient Inventory</h3>
            <p style="margin:0 0 12px;font-size:13px;color:#2B3A55;line-height:1.5;">The following item${shortages.length > 1 ? 's don\u2019t' : ' doesn\u2019t'} have enough stock for all selected addresses:</p>
            <ul style="margin:0 0 16px;padding-left:20px;font-size:13px;color:#2B3A55;line-height:1.7;">${listHtml}</ul>
            <p style="margin:0 0 20px;font-size:12px;color:#66717E;">You can proceed anyway or go back to adjust your cart or address selection.</p>
            <div style="display:flex;justify-content:flex-end;gap:8px;">
              <button id="vc-ma-inv-cancel"  style="padding:8px 16px;border:1px solid rgba(29,38,54,0.15);border-radius:6px;background:#fff;font-size:13px;cursor:pointer;color:#2B3A55;">Go back</button>
              <button id="vc-ma-inv-proceed" style="padding:8px 16px;border:none;border-radius:6px;background:#1D2636;color:#fff;font-size:13px;cursor:pointer;">Proceed anyway</button>
            </div>
          </div>
        `;
        document.body.appendChild(overlay);
        const close = result => { overlay.remove(); resolve(result); };
        overlay.querySelector('#vc-ma-inv-cancel').addEventListener('click',  () => close(false));
        overlay.querySelector('#vc-ma-inv-proceed').addEventListener('click', () => close(true));
        overlay.addEventListener('click', e => { if (e.target === overlay) close(false); });
      });
    }

    // ── Multi-address shipping rates ─────────────────────
    async _fetchMaRate(idx, rateEl) {
      const auth = window.__vaAuth;
      if (!auth || !rateEl) return;
      const a = this._maAddresses[idx];
      if (!a) return;

      const submitBtn = document.getElementById('vc-ma-submit');
      if (submitBtn) submitBtn.disabled = true;
      rateEl.innerHTML = '<span class="vc-ma-rate-loading">Loading…</span>';

      if (!this._maCartData) {
        try {
          const r = await fetch('/cart.js');
          this._maCartData = await r.json();
        } catch(_) { this._maCartData = { total_price: 0, items: [] }; }
      }
      const subtotal = (this._maCartData.original_total_price ?? this._maCartData.total_price ?? 0) / 100;
      const weight   = (this._maCartData.items || []).reduce((s, i) => s + (i.grams || 0) * (i.quantity || 0), 0) / 453.592;

      try {
        const resp = await fetch(auth.proxy, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop,
            action: 'checkout-options',
            subtotal, weight: weight || 0.01,
            ship_to: {
              name:     a.name     || '',
              address1: a.address1 || '',
              address2: a.address2 || '',
              city:     a.city     || '',
              state:    a.state    || '',
              zip:      a.zip      || '',
              country:  a.country  || 'US',
              phone:    a.phone    || '',
            }
          })
        });
        const result = await resp.json();
        if (!result.ok) throw new Error(result.error || 'API error');

        const rates = (result.data?.rateOptions || []).filter(r => {
          if (r.errorMessages?.length) return false;
          const name = (r.serviceDisplayName || ((r.carrierFriendlyName || '') + ' ' + (r.serviceCode || ''))).toLowerCase();
          return !name.includes('pickup');
        });

        if (!rates.length) { rateEl.textContent = 'No rates'; return; }

        const select = document.createElement('select');
        select.className = 'vc-ma-rate-select';
        for (const rate of rates) {
          const price = rate.buyerFreightChargeLCY ?? rate.amount ?? 0;
          const name  = rate.serviceDisplayName || ((rate.carrierFriendlyName || '') + ' ' + (rate.serviceCode || '')).trim();
          const opt   = document.createElement('option');
          opt.value       = price;
          opt.dataset.erp = JSON.stringify({
            agent:    rate.bcShippingAgentCode        ?? null,
            service:  rate.bcShippingAgentServiceCode ?? null,
            buyer:    rate.buyerFreightChargeLCY      ?? null,
            estimate: rate.estimatedFreightLCY        ?? null,
            quote:    rate.quotedFreightChargeLCY     ?? null,
            free:     rate.isFreeShipping             ?? false,
            fixed:    rate.isFixedFreightCharge       ?? false,
          });
          opt.textContent = price == 0 ? 'Free — ' + name : '$' + Number(price).toFixed(2) + ' — ' + name;
          select.appendChild(opt);
        }
        rateEl.innerHTML = '';
        rateEl.appendChild(select);
      } catch(err) {
        let msg = err.message.replace(/^HTTP \d+ - /, '').replace(/^[^:]+:\s*/, '').replace(/\s*\([^)]+\)\s*$/, '').trim();
        rateEl.innerHTML = '<em class="vc-ma-rate-err">' + msg + '</em>';
      } finally {
        // Re-enable submit once all in-flight rate loads are done
        if (submitBtn) {
          const anyLoading = document.querySelector('.vc-ma-rate-loading');
          const n = document.querySelectorAll('.vc-ma-check:checked').length;
          submitBtn.disabled = !!(anyLoading || n < 1);
        }
      }
    }

    // ── Net terms ────────────────────────────────────────
    async _initNetTerms() {
      if (!window.__vaCustomerInfo) return;
      const data = await window.__vaCustomerInfo;
      const terms = data?.paymentTermsCode || data?.PaymentTermsCode || '';
      if (!terms || terms === '0') return;
      const row  = document.getElementById('vc-net-terms');
      const code = document.getElementById('vc-terms-code');
      if (code) code.textContent = terms;
      if (row)  row.style.display = '';
    }
  }

  customElements.define('valor-cart-page', ValorCartPage);

  // Reload on bfcache restore — Liquid-rendered data-key values go stale when the server cart
  // is modified (e.g. multi-address quantity scaling) before the user navigates away.
  // Must be at script level, not in connectedCallback, because connectedCallback doesn't run on bfcache restore.
  window.addEventListener('pageshow', (e) => { if (e.persisted) window.location.reload(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valor-category"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.vr-cat-scroll-wrap').forEach(wrap => {
  const grid = wrap.querySelector('.vr-cat-grid');
  const prev = wrap.querySelector('.vr-cat-nav--prev');
  const next = wrap.querySelector('.vr-cat-nav--next');
  if (!grid || !prev || !next) return;

  function update() {
    prev.hidden = grid.scrollLeft <= 1;
    next.hidden = grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 1;
  }

  prev.addEventListener('click', () => grid.scrollBy({ left: -grid.clientWidth * 0.8, behavior: 'smooth' }));
  next.addEventListener('click', () => grid.scrollBy({ left: grid.clientWidth * 0.8, behavior: 'smooth' }));
  grid.addEventListener('scroll', update, { passive: true });
  update();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valor-coming-soon"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var products = window.__csProducts || [];
  var state = { date: 'all' };

  var TODAY = new Date();
  TODAY.setHours(0, 0, 0, 0);

  var MON = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function parseD(iso) { return new Date(iso + 'T00:00:00'); }
  function fShort(d) { return MON[d.getMonth()] + ' ' + d.getDate(); }
  function fNum(d) { return (d.getMonth() + 1) + '/' + d.getDate(); }
  function fmtMoney(cents) { return '$' + (cents / 100).toFixed(2); }

  function escHtml(s) {
    return String(s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }

  // Collect distinct future dates across all products
  function buildBuckets() {
    var map = {};
    products.forEach(function (p) {
      var dates = p.next_arrival;
      if (!dates) return;
      // next_arrival may be an array or a single string
      if (!Array.isArray(dates)) dates = [dates];
      dates.forEach(function (iso) {
        if (!iso) return;
        var d = parseD(iso);
        if (d < TODAY) return; // skip past dates
        if (!map[iso]) map[iso] = [];
        map[iso].push(p);
      });
    });
    var sorted = Object.keys(map).sort();
    return sorted.map(function (iso) { return { date: iso, products: map[iso] }; });
  }

  // Earliest future arrival date for a product (for card ETA display)
  function getEta(p) {
    var dates = p.next_arrival;
    if (!dates) return null;
    if (!Array.isArray(dates)) dates = [dates];
    var future = dates.filter(function (iso) { return iso && parseD(iso) >= TODAY; });
    future.sort();
    return future.length ? future[0] : null;
  }

  function renderFilter(buckets) {
    var inner = document.getElementById('cs-flt-inner');
    if (!inner) return;
    var pills = '<button class="cs-dp-all' + (state.date === 'all' ? ' active' : '') + '" data-date="all">All dates</button>';
    buckets.forEach(function (b) {
      var active = state.date === b.date;
      pills += '<span class="cs-dgrp' + (active ? ' active' : '') + '">'
        + '<button class="cs-dg-date" data-date="' + escHtml(b.date) + '">' + escHtml(fShort(parseD(b.date))) + '</button>'
        + '</span>';
    });
    inner.innerHTML = '<span class="cs-flt-lbl">Expected arrival date</span>'
      + '<div class="cs-flt-pills">' + pills + '</div>';
  }

  function card(p) {
    var eta = getEta(p);
    var imgHtml = p.image
      ? '<img src="' + escHtml(p.image) + '" alt="' + escHtml(p.title) + '" loading="lazy">'
      : '<svg class="cs-ic-img-empty" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><rect x="6" y="2" width="12" height="20" rx="2.5"/><path d="M11 19h2"/></svg>';

    return '<a href="' + escHtml(p.url) + '" class="cs-card">'
      + '<div class="cs-ic-img">'
      + imgHtml
      + '<div class="cs-ic-badges"><span class="cs-ic-badge soon">Coming Soon</span></div>'
      + '</div>'
      + '<div class="cs-ic-info">'
      + '<div class="cs-ic-brand">' + escHtml(p.vendor) + '</div>'
      + '<div class="cs-ic-name">' + escHtml(p.title) + '</div>'
      + (p.sku ? '<div class="cs-ic-sku">' + escHtml(p.sku) + '</div>' : '')
      + '<div class="cs-ic-price">'
      + '<div><div class="cs-ic-wholesale">Your price</div><div class="cs-ic-amount">' + fmtMoney(p.price) + '</div></div>'
      + '</div>'
      + (eta ? '<div class="cs-ic-stock eta"><span class="dot"></span>ETA ' + escHtml(fNum(parseD(eta))) + '</div>' : '')
      + '<div class="cs-ic-action">'
      + '<button class="cs-ic-notify-btn" onclick="event.preventDefault()">'
      + '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9M13.7 21a2 2 0 0 1-3.4 0"/></svg>'
      + 'Notify Me When Available'
      + '</button>'
      + '</div>'
      + '</div>'
      + '</a>';
  }

  function getVisible(buckets) {
    if (state.date === 'all') {
      var seen = {};
      var result = [];
      buckets.forEach(function (b) {
        b.products.forEach(function (p) {
          if (!seen[p.id]) { seen[p.id] = true; result.push(p); }
        });
      });
      return result;
    }
    var bucket = null;
    buckets.forEach(function (b) { if (b.date === state.date) bucket = b; });
    return bucket ? bucket.products : [];
  }

  function render() {
    var buckets = buildBuckets();
    renderFilter(buckets);

    var stage = document.getElementById('cs-stage');
    if (!stage) return;

    var visible = getVisible(buckets);

    if (!visible.length) {
      var msg = buckets.length === 0
        ? 'No upcoming arrivals found. Add <code>custom.next_arrival</code> dates to products in this collection.'
        : 'No products for this date.';
      stage.innerHTML = '<div class="cs-empty">' + msg + '</div>';
      return;
    }

    stage.innerHTML = '<div class="cs-grid">' + visible.map(card).join('') + '</div>';
  }

  // Filter click (delegated)
  var inner = document.getElementById('cs-flt-inner');
  if (inner) {
    inner.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-date]');
      if (!btn) return;
      state.date = btn.getAttribute('data-date');
      render();
    });
  }

  render();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valor-desktop-nav"] && !Shopify.designMode) return;
  try {
    
(function () {
  var items = document.querySelectorAll('.vdn__item--dd');

  items.forEach(function (item) {
    var trigger = item.querySelector('.vdn__trigger');
    if (!trigger) return;

    // Keep aria-expanded in sync with CSS hover state
    item.addEventListener('mouseenter', function () {
      trigger.setAttribute('aria-expanded', 'true');
    });
    item.addEventListener('mouseleave', function () {
      trigger.setAttribute('aria-expanded', 'false');
    });

    // Click: close others, toggle this (keyboard / touch support)
    trigger.addEventListener('click', function () {
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      items.forEach(function (other) {
        if (other !== item) {
          var t = other.querySelector('.vdn__trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        }
      });
      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });
  });

  // Escape closes all
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    items.forEach(function (item) {
      var t = item.querySelector('.vdn__trigger');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  });

  // Click outside closes all
  document.addEventListener('click', function (e) {
    if (e.target.closest('.vdn__item--dd')) return;
    items.forEach(function (item) {
      var t = item.querySelector('.vdn__trigger');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  });

  document.querySelectorAll('.vdn__mega--designlab').forEach(function (menu) {
    var railItems = menu.querySelectorAll('.vdn__dl-rail-item');
    var panels = menu.querySelectorAll('.vdn__dl-panel');

    function activate(category) {
      railItems.forEach(function (button) {
        var active = button.getAttribute('data-vdn-dlcat') === category;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var active = panel.getAttribute('data-vdn-dlpanel') === category;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    }

    railItems.forEach(function (button) {
      var category = button.getAttribute('data-vdn-dlcat');
      button.addEventListener('mouseenter', function () { activate(category); });
      button.addEventListener('focus', function () { activate(category); });
      button.addEventListener('click', function (event) {
        event.preventDefault();
        activate(category);
      });
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valor-menu-drawer"]) return;
  try {
    
(function () {
  /* Shared overlay singleton */
  function _getValorOverlay() {
    if (window.__valorDrawerOverlay) return window.__valorDrawerOverlay;
    const el = document.createElement('div');
    el.className = 'valor-drawer-overlay';
    document.body.appendChild(el);
    const ov = {
      el,
      _handler: null,
      show(onClose) {
        el.classList.add('valor-open');
        if (this._handler) el.removeEventListener('click', this._handler);
        this._handler = () => { this.hide(); onClose && onClose(); };
        el.addEventListener('click', this._handler, { once: true });
      },
      hide() {
        el.classList.remove('valor-open');
        if (this._handler) { el.removeEventListener('click', this._handler); this._handler = null; }
      },
    };
    return (window.__valorDrawerOverlay = ov);
  }

  class ValorMenuDrawer extends HTMLElement {
    connectedCallback() {
      this._initTabs();
      this._initAccordions();
      this._initOpen();
    }

    _initOpen() {
      /* Trigger from header hamburger button */
      document.addEventListener('vmd:open-menu', () => this.open());

      /* Close button inside drawer */
      this.querySelector('[data-vmd-close]')?.addEventListener('click', () => this.close());

      /* Register link → open popup instead of redirecting */
      this.querySelector('.vmd-account-card__register')?.addEventListener('click', (e) => {
        e.preventDefault();
        this.close();
        setTimeout(() => document.dispatchEvent(new CustomEvent('vr:open-register')), 0);
      });

      /* Escape key */
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.classList.contains('vmd-open')) this.close();
      });
    }

    open() {
      this.classList.add('vmd-open');
      document.body.classList.add('vcd-scroll-locked');
      _getValorOverlay().show(() => this.close());
    }

    close() {
      this.classList.remove('vmd-open');
      document.body.classList.remove('vcd-scroll-locked');
      _getValorOverlay().hide();
      const trigger = document.querySelector('[data-vmd-trigger]');
      trigger?.setAttribute('aria-expanded', 'false');
      trigger?.focus();
    }

    _initTabs() {
      const tabs = this.querySelectorAll('[data-vmd-tab]');
      const panels = this.querySelectorAll('[data-vmd-panel]');
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const target = tab.dataset.vmdTab;
          tabs.forEach((t) => {
            t.classList.remove('vmd-tab--active');
            t.setAttribute('aria-selected', 'false');
          });
          panels.forEach((p) => {
            const active = p.dataset.vmdPanel === target;
            p.hidden = !active;
            p.classList.toggle('vmd-panel--active', active);
          });
          tab.classList.add('vmd-tab--active');
          tab.setAttribute('aria-selected', 'true');
          const body = this.querySelector('.vmd-body');
          if (body) body.scrollTop = 0;
        });
      });
    }

    _initAccordions() {
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-vmd-acc]');
        if (!btn) return;
        const item = btn.closest('[data-vmd-acc-item]');
        if (!item) return;
        const wasOpen = item.classList.contains('vmd-acc--open');
        const panel = btn.closest('[data-vmd-panel]');
        if (panel) {
          panel.querySelectorAll('[data-vmd-acc-item].vmd-acc--open').forEach((el) => {
            el.classList.remove('vmd-acc--open');
            const subs = el.querySelector('.vmd-acc-subs');
            if (subs) subs.style.maxHeight = '0';
            const b = el.querySelector('[data-vmd-acc]');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
        }
        if (!wasOpen) {
          item.classList.add('vmd-acc--open');
          btn.setAttribute('aria-expanded', 'true');
          const subs = item.querySelector('.vmd-acc-subs');
          if (subs) subs.style.maxHeight = subs.scrollHeight + 'px';
        }
      });
    }
  }

  if (!customElements.get('valor-menu-drawer')) {
    customElements.define('valor-menu-drawer', ValorMenuDrawer);
  }
})();

// Drawer-close on shopify-account click disabled for testing — re-enable if dialog appears behind drawer
// (function () {
//   document.addEventListener('click', function (e) {
//     if (!e.target.closest('shopify-account.vmd-account-sa')) return;
//     var drawer = document.querySelector('valor-menu-drawer.vmd-open');
//     if (drawer && typeof drawer.close === 'function') drawer.close();
//   });
// })();

// B2B account card: populate company name, market, and avatar initials from cached customer-info
(function () {
  var nameEl   = document.getElementById('vmd-account-card-name');
  var marketEl = document.getElementById('vmd-account-card-market');
  var avatarEl = document.getElementById('vmd-account-avatar');
  if (!nameEl && !marketEl) return;
  function applyInfo(d) {
    var company = d.name || d.Name || '';
    var handle  = d.shopifyMarketHandle || '';
    if (company && nameEl)  nameEl.textContent  = company;
    if (handle  && marketEl) marketEl.textContent = handle.toLowerCase().replace(/[-_]/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }
  if (window.__vaCustomerInfo) window.__vaCustomerInfo.then(function (d) { if (d) applyInfo(d); });
})();



  } catch(e) { console.error(e); }
})();
})();
